import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import theme from "../../theme/theme";
import styled from "styled-components";

const DashboardLink = styled.div`
  border-bottom: ${(props) =>
    `${props.isUnderlineVisible ? `3px solid ${theme.colors.primary}` : ""}`};
  padding: 5px 5px;
  letter-spacing: 0px;
  line-height: 1.25;
  text-decoration: none;
  color: ${theme.colors.primaryStrong2X};
  height: fit-content;
  font-weight: 700;
  cursor: pointer;

  @media (max-width: 480px) {
    display: flex;
    flex-direction: ${(props) => `${props.isDashboard ? `row` : "column"}`};
    align-items: center;
    margin: ${(props) => `${props.isDashboard ? `0 10px 10px 0` : "5px"}`};
    padding: 0;
  }

  &:hover {
    color: ${theme.colors.primary};
  }

  .userName {
    color: ${theme.colors.primary};
  }
`;

const WelcomeMessage = ({ actionOnClick }) => {
  const { location } = useHistory();
  const isDashboard =
    location.pathname === "/strategy-screen" ||
    location.pathname === "/strategy-screen/:fromGoalSubmission" ||
    location.pathname === "/strategy-screen/fromManage";
  const { userAccountDetails } = useSelector((state) => state.user);
  let firstName = userAccountDetails?.firstName;

  return (
    <>
      {firstName && (
        <DashboardLink
          isUnderlineVisible={false}
          onClick={actionOnClick}
          isDashboard={isDashboard}
        >
          Welcome,{" "}
          <span className="userName">
            {firstName} <FontAwesomeIcon icon={faUserCircle} />
          </span>
        </DashboardLink>
      )}
    </>
  );
};

export default WelcomeMessage;
